export default __webpack_public_path__ + "static/BannerPattern-feb7d653895909dd894ea7f91cfe2314.png";